/*
 * @Author: 张天昊
 * @Date: 2024-06-06 11:43:54
 * @LastEditTime: 2024-06-06 11:44:51
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useFilePreview.js
 */
import { ref } from 'vue';
export function useFilePreview() {
  const filePreviewerInst = ref();

  function onPreview({ fileType, url }) {
    filePreviewerInst.value && filePreviewerInst.value.preview(fileType, url);
  }

  return {
    filePreviewerInst,
    onPreview
  };
}
